import { Link } from '@dodilio/ui-design-lib';
import { signInToFinish } from '../auth';

/**
 * "Sign in", from anywhere in signup. It goes through the org step, so an
 * account without an organization makes one there instead of being sent to
 * the console, which would only send it back (the loop of 2026-10-30).
 *
 * `email` is required, even when undefined: where signup knows who this is,
 * it must say so. Keycloak then can't hand back a different person's session
 * (the library asks for credentials if someone else is signed in).
 */
export const SignInLink = ({ email, children = 'Sign in' }: { email: string | undefined; children?: string }) => (
    <Link
        href="/signup/org"
        underline="always"
        onClick={(e: React.MouseEvent) => { e.preventDefault(); void signInToFinish(email); }}
    >
        {children}
    </Link>
);
